export const USERTYPE = [
    { Name: "Administratör", Value: "admin" },
    { Name: "Klient", Value: "client" },
  ];